import { ITemplateScope } from "AngularFormly";
import { ListFieldController } from "../listFieldController";
import { ITimeoutService } from "angular";

export class ConfirmationListFieldTypeController extends ListFieldController {
  static $inject = ["$scope", "$timeout"];

  tempActive: boolean = false;

  constructor($scope: ITemplateScope, $timeout: ITimeoutService) {
    super($scope);

    //checkbox we are using doesn't show proper value if disabled.
    //Here we temporarily activate it so it will render the correct value
    //and then we disable it

    if (!this.workItemController.fieldActive && this.value) {
      this.tempActive = true;
      $timeout(0).then(() => {
        this.tempActive = false;
      });
    }
  }
}
